export default __webpack_public_path__ + "static/media/redde-liv.a8a1924e.jpg";